import axios from 'axios';

// handler for client side browser errors
window.errorCounter = 0;
window.errorMaxCount = 5;

window.addEventListener('error', function (errorEvent) {
    "use strict";

    let message = errorEvent.message;
    const col = errorEvent.colno;
    const line = errorEvent.lineno;
    const err = errorEvent.error;
    const source = errorEvent.filename;

    const dontLog = [
        'Error loading script',
        'Script error.',
        'Object required',
    ];

    let log = true;

    if (message) {
        for (let i = 0; i < dontLog.length; i++) {
            if (message.indexOf(dontLog[i]) > -1) {
                log = false;
                break;
            }
        }
    }

    if (log && source && source.indexOf('js/api.js') > -1) {
        if (window.errorCounter++ < window.errorMaxCount) {
            var errorObj = {
                "message": message,
                "url": document.location.href,
                "handled_by": "window.onerror",
                "file": source,
                "line": line + (col ? ":" + col : "")
            };

            message += "\n" + JSON.stringify(errorObj, null, 4);

            if (err !== undefined) {
                message += "\nstack: " + err.stack;
            }

            if (typeof TABS !== 'undefined' && typeof TABS.booking !== 'undefined' && typeof TABS.booking.request !== 'undefined') {
                axios.post(TABS.api.getEndPoint('ajax/js/log'), {
                    type: "client",
                    message: message
                });
            }
        }
    }
});
